import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "assets/theme";
import themeDark from "assets/theme-dark";
import SignIn from "login";
import App from "App";
import { useMaterialUIController } from "context";
import Dashboard from "layouts/dashboard";

export default function AppRoute() {
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;
  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {/* <h1>hola mirar si esto persiste</h1> */}
      <Routes>
        {/* <Route path="App/*" element={<App />} />
        <Route path="/" element={<SignIn />}></Route> */}
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        <Route path="*" element={<App />} />
        <Route path="/login" element={<SignIn />}></Route>
      </Routes>
    </ThemeProvider>
  );
}
